<template>
  <header class="header">
    <img src="../../assets/icon/main/logo.png"
         class="header-logo"
         alt="">
    <span style="margin-left: auto;"></span>
    <button v-if="!isVip"
            class="header-vip"
            @click="handleVip">
      <img src="../../assets/icon/main/vip.png"
           class="header-vip-logo"
           alt="">
      开通VIP
    </button>
    <button v-if="!isLogin"
            class="header-login"
            @click="handleLogin">
      登录/注册
    </button>
    <div v-else
         class="header-info">
      <img :src="avatar"
           class="header-info-avatar"
           alt="" @click="handleVip">
    </div>
  </header>
</template>

<script>
import { clientLogin, clientReport } from '@/client'
import { mapGetters } from 'vuex'
import { PDF_TABLE, PAGE_ACTION, PDF_PAGE } from '@/client/constant'
import { getOpenFrom, getPageByRouter } from '@/utils'
export default {
  name: 'Header',
  data () {
    return {
      openFrom: 0,
    }
  },
  computed: {
    ...mapGetters([
      'isVip',
      'avatar',
      'isLogin'
    ])
  },
  mounted () {
    this.openFrom = getOpenFrom()
  },
  methods: {
    handleLogin () {
      clientLogin()
      // REPORT 点击登录/注册按钮触发埋点上报
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: this.getPage(),
        click: PAGE_ACTION.LOGIN
      })
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: PDF_PAGE.LOGIN_DIALOG,
        click: PAGE_ACTION.DEFAULT
      })
    },
    handleVip () {
      this.$store.commit('openVipWindow')
      // REPORT 点击开通VIP按钮触发埋点上报
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: this.getPage(),
        click: PAGE_ACTION.OPEN_VIP
      })
    },
    /**
     * 获取当前页
     */
    getPage () {
      const router = this.$route.path.split('/').pop().split('?')[0]
      return getPageByRouter(router)
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/styleVariable";
  @import "../../assets/style/styleMixins";
  .header{
    height: 80px;
    width: @page_width;
    display: flex;
    align-items: center;
    margin: 0 auto;
    &-image{
      height: 50px;
    }
    &-vip{
      .flex_center_mixins;
      .clear_button_default_mixins;
      height: 36px;
      padding: 0 18px;
      border: 1px solid #548EF8;
      border-radius: 4px;
      margin-right: 10px;
      color: #548EF8;
      background-color: #fff;
      font-size: 14px;
      &-logo{
        height: 20px;
        margin-right: 10px;
      }
    }
    &-login{
      .flex_center_mixins;
      .clear_button_default_mixins;
      height: 36px;
      font-size: 14px;
      padding: 0 24px;
      background: #548EF8;
      border-radius: 4px;
      border-color: transparent;
      color: white;
    }
    &-info{
      height: 36px;
      width: 36px;
      &-avatar{
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }
  }
</style>
